export const syntaxHighlightingThemeNames = {
    light: 'light-plus',
    dark: 'dark-plus',
} as const
